import { connect } from 'react-redux';

import { ServerImage as BaseServerImage } from '@mews-distributor/common';
import { getImageBaseUrl } from '../../modules/configuration/selectors';
import type { ApplicationState } from '../../types';

const mapStateToProps = (state: ApplicationState) => ({
    imageBaseUrl: getImageBaseUrl(state),
});

export const ServerImage = connect(mapStateToProps)(BaseServerImage);
